import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { ShieldCheckIcon } from '@heroicons/react/24/solid';
import { useLocation, useSubmit } from '@remix-run/react';

import type { SetCookieOptions } from '~/hooks/useUtils/useCookies';

import Button from '../Button';
import SlideUpModal from '../Modal/SlideUpModal';

interface Props {
  justLoggedIn?: boolean;
  setCookie: (options: SetCookieOptions) => void;
}

const AdminBadge = ({ justLoggedIn, setCookie }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const submit = useSubmit();
  const { t } = useTranslation();
  const location = useLocation();

  const handleLogout = () => {
    setCookie({ name: 'admin_logged_in', value: 'true', days: 0 });
    const formData = new FormData();
    formData.append('logout_admin', 'true');
    formData.append('pathname', location.pathname);
    submit(formData, { method: 'post', action: '/logout' });
  };

  useEffect(() => {
    if (justLoggedIn) {
      toast.success(t('login.success.admin'));
      setCookie({ name: 'admin_logged_in', value: 'true', days: 4 });
    }
  }, [justLoggedIn, setCookie]);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className={
          'pointer-events-auto fixed right-3 top-14 z-40 flex rounded-lg bg-white p-2 shadow-xl ring-1 ring-black ring-opacity-5 lg:right-4'
        }
      >
        <ShieldCheckIcon className="h-4 w-4 text-wt-primary" />
      </button>
      <SlideUpModal
        title={`${t('admin.modal.title')}`}
        description={`${t('admin.modal.description')}`}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <div className="flex w-full justify-end space-x-2">
          <Button
            type="button"
            variant="ghost"
            className="shadow-none"
            onClick={() => {
              handleLogout();
              setIsModalOpen(false);
            }}
          >
            {t('shared.cta.logout')}
          </Button>
          <Button type="button" variant="primary" onClick={() => setIsModalOpen(false)}>
            {t('shared.cta.continue')}
          </Button>
        </div>
      </SlideUpModal>
    </>
  );
};

export default AdminBadge;
